import { Box } from "@material-ui/core";
import { B2BSpinner } from "halifax";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { FlightFare, IFlightListData } from "redmond";
import { RecommendedFlightInfo } from "../RecommendedFlightInfo";
import { RecommendedFlightInfoProps } from "../RecommendedFlightInfo/component";
import { FlightListInfo } from "../FlightListInfo";

interface DesktopFlightListProps
  extends Omit<RecommendedFlightInfoProps, "flight" | "selectedFare"> {
  faresToShow: IFlightListData[];
  sortedFlights: IFlightListData[];
  flights: any;
  selectedFareId: string;
  isOutgoing: boolean;
  outgoingRecommendedFlight: any;
  returnRecommendedFlight: IFlightListData | null | undefined;
  fetchMoreData: () => void;
  isXmodRedesign?: boolean;
}

export const DesktopFlightList = ({
  faresToShow,
  sortedFlights,
  flights,
  selectedFareId,
  isOutgoing,
  outgoingRecommendedFlight,
  returnRecommendedFlight,
  fetchMoreData,
  expandedFlight,
  maxPriceFilter,
  packageNightCountBasedOnAvailability,
  packageNightCountBasedOnOutboundFlight,
  packagesByOutboundFareSlice,
  packagesByReturnFareSlice,
  fareClassFilter,
  isAgentPortal,
  departureDate,
  returnDate,
  hotelShopDateRange,
  airports,
  rewardsKey,
  isTripDetailsLoading,
  expandedFareDetails,
  handleClickAlgomerchTag,
  setOpenModal,
  handleSliceSelect,
  setClickedFareId,
  setExpandedFlight,
  handleFareSelect,
  isXmodRedesign,
  selectedRewardsAccount,
  canEarnRewards,
}: DesktopFlightListProps) => {
  const getSelectedFare = (flight: any, selectedFareId: string): unknown => {
    return (
      flight?.fares.find(
        (fare: any) => fare?.example?.fare === selectedFareId,
      ) || flight?.fares[0]
    );
  };

  const recommendedFlight = isOutgoing
    ? outgoingRecommendedFlight
    : returnRecommendedFlight;
  const selectedRecommendedFare = getSelectedFare(
    recommendedFlight,
    selectedFareId,
  ) as any;

  return (
    <InfiniteScroll
      dataLength={faresToShow.length}
      next={fetchMoreData}
      hasMore={faresToShow.length < sortedFlights.length}
      loader={
        <Box className="loading-flights">
          <B2BSpinner classes={["loading-flights-bunny"]} />
        </Box>
      }
    >
      <RecommendedFlightInfo
        flight={recommendedFlight}
        flights={flights}
        selectedFare={selectedRecommendedFare}
        selectedFareId={selectedFareId}
        expandedFlight={expandedFlight}
        maxPriceFilter={maxPriceFilter}
        isOutgoing={isOutgoing}
        packageNightCountBasedOnAvailability={
          packageNightCountBasedOnAvailability
        }
        packageNightCountBasedOnOutboundFlight={
          packageNightCountBasedOnOutboundFlight
        }
        packagesByOutboundFareSlice={packagesByOutboundFareSlice}
        packagesByReturnFareSlice={packagesByReturnFareSlice}
        fareClassFilter={fareClassFilter}
        isAgentPortal={isAgentPortal}
        departureDate={departureDate}
        returnDate={returnDate}
        hotelShopDateRange={hotelShopDateRange}
        airports={airports}
        rewardsKey={rewardsKey}
        isTripDetailsLoading={!!isTripDetailsLoading}
        expandedFareDetails={expandedFareDetails}
        handleClickAlgomerchTag={handleClickAlgomerchTag}
        setOpenModal={setOpenModal}
        handleFareSelect={handleFareSelect}
        setClickedFareId={setClickedFareId}
        setExpandedFlight={setExpandedFlight}
        handleSliceSelect={handleSliceSelect}
        isXmodRedesign={isXmodRedesign}
        selectedRewardsAccount={selectedRewardsAccount}
        canEarnRewards={canEarnRewards}
      />
      {faresToShow.map((flight, index: number) => {
        const flightSliceId = flight.slice;
        const flightSlice = flights.slices[flightSliceId];
        if (!flightSlice || flightSliceId === recommendedFlight?.slice) {
          return null;
        }

        const selectedFare = getSelectedFare(
          flight,
          selectedFareId,
        ) as FlightFare;

        return (
          <FlightListInfo
            key={flightSlice.id}
            selectedFare={selectedFare}
            selectedFareId={selectedFareId}
            showListView
            slice={flightSlice}
            flight={flight}
            index={index}
            flights={flights}
            expandedFlight={expandedFlight}
            fareClassFilter={fareClassFilter}
            maxPriceFilter={maxPriceFilter}
            isOutgoing={isOutgoing}
            packageNightCountBasedOnAvailability={
              packageNightCountBasedOnAvailability
            }
            packageNightCountBasedOnOutboundFlight={
              packageNightCountBasedOnOutboundFlight
            }
            packagesByOutboundFareSlice={packagesByOutboundFareSlice}
            packagesByReturnFareSlice={packagesByReturnFareSlice}
            departureDate={departureDate}
            returnDate={returnDate}
            hotelShopDateRange={hotelShopDateRange}
            isTripDetailsLoading={isTripDetailsLoading}
            airports={airports}
            rewardsKey={rewardsKey}
            isAgentPortal={isAgentPortal}
            expandedFareDetails={expandedFareDetails}
            handleClickAlgomerchTag={handleClickAlgomerchTag}
            setOpenModal={setOpenModal}
            handleSliceSelect={handleSliceSelect}
            setClickedFareId={setClickedFareId}
            setExpandedFlight={setExpandedFlight}
            handleFareSelect={handleFareSelect}
            isXmodRedesign={isXmodRedesign}
            selectedRewardsAccount={selectedRewardsAccount}
            canEarnRewards={canEarnRewards}
          />
        );
      })}
    </InfiniteScroll>
  );
};
